import styled from 'styled-components';
import { style } from '../../../style';
import { transparent } from 'material-ui/styles/colors';

export const Menu = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 60px;
  padding: 0px 100px 0px 16px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  width: 100;
  justify-content: space-between;
`;

export const MenuOption = styled.button`
  position: relative;
  border: none;
  background: none;
  padding: 10px 5px;
  font-size: 16px;
  cursor: pointer;
  color: #87868a;
  height: 38px;

  &.active {
    color: #2e63fb;
    border-bottom: 1px solid #2e63fb;
  }

  &:hover {
    color: #2e63fb;
  }
`;

export const CoursesActions = styled.button`
  border: 1px solid #2e63fb;
  background-color: ${(props) => (props.save ? '#2e63fb' : transparent)};
  color: ${(props) => (props.save ? '#ffffff' : '#2e63fb')};

  border-radius: 8px;
  padding: 6px 20px;
  font-size: 16px;
  font-family: Rubik;

  cursor: pointer;
`;
